// import React, { useEffect, useState } from "react";
// import {
//     Dialog,
//     DialogContent,
//     DialogTitle,
//     Stepper,
//     Step,
//     StepLabel,
//     IconButton,
//     Typography,
//     useMediaQuery,
//     useTheme
// } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";

// import DetailTabContent from "./DetailTabContent";
// import ImageTabContent from "./ImageTabContent";
// import VariantTabContent from "./VariantTabContent";
// import AttributeTabContent from "./AttributeTabContent";
// import FinalTabContent from "./FinalTabContent";

// import { useDispatch, useSelector } from "react-redux";
// import { getAllCategory } from "../../../User/State/Category/Action";
// import { getVendors } from "../../State/Vendor/Action";
// import { getAllBrand } from "../../../User/State/Brand/Action";
// import { getAllColor } from "../../../User/State/Color/Action";
// import { getAllSize } from "../../../User/State/Size/Action";
// import { createFullProduct, updateFullProduct } from "../../../Vendor/State/Product/Action";

// const steps = [
//     "Details",
//     "Images",
//     "Variants",
//     // "Attributes",
//     "Finish"
// ];

// const ManageProductModal = ({ open, onClose, editData }) => {
//     const [selectedCategoryId, setSelectedCategoryId] = useState(0);
//     const [selectedSubCategoryId, setSelectedSubCategoryId] = useState(0);

//     const dispatch = useDispatch();
//     const theme = useTheme();
//     const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
//     const isEditMode = Boolean(editData);

//     const { vendorProducts, size, color, publicCategory, adminVendor, brands } =
//         useSelector((store) => store);

//     const [activeStep, setActiveStep] = useState(0);

//     const [productData, setProductData] = useState({
//         vendorId: "",
//         title: "",
//         description: "",
//         categoryId: "",
//         subCategoryId: "",
//         productCategoryId: "",
//         brandName: "",
//         productColorId: "",
//         colorId: "",
//         gst: "",
//         returnAllowed: false,
//         customizationAllowed: false,
//         customizationPrice: 0,
//         images: [],
//         variants: []
//     });

//     // ================= EDIT MODE LOAD =================
//     useEffect(() => {
//         if (editData) {
//             setProductData({
//                 vendorId: editData.vendor?.id || "",
//                 title: editData.title || "",
//                 description: editData.description || "",
//                 categoryId: editData.category?.id || "",
//                 subCategoryId: editData.subCategory?.id || "",
//                 productCategoryId: editData.productCategory?.id || "",
//                 colorId: editData.colors?.[0]?.color?.id || "",
//                 productColorId: editData.colors?.[0]?.id || "",
//                 brandName: editData.brand?.name || "",
//                 gst: editData.igst || "",
//                 returnAllowed: editData?.returnAllowed?.toLowerCase() === "yes",
//                 customizationAllowed: editData?.customizationAllowed || false,
//                 customizationPrice: editData?.customizationPrice || 0,

//                 // 🔥 IMAGES FIXED
//                 images: editData.images?.map(img => ({
//                     id: img.id,
//                     tempId: null,
//                     preview: img.fullUrl,
//                     isPrimary: img.isPrimary,
//                     file: null
//                 })) || [],

//                 // 🔥 VARIANTS FIXED
//                 variants: editData.variants?.map(v => ({
//                     id: v.id,
//                     tempId: null,
//                     sizeId: v.size?.id,
//                     price: v.price,
//                     stockQuantity: v.stockQuantity,
//                     vendorDiscountPercentage: v.vendorDiscountPercentage,
//                     marginPrice: v.marginPrice,
//                     adminDiscountPercentage: v.adminDiscountPercentage,
//                 })) || []
//             });
//             setSelectedCategoryId(editData.category.id)
//             setSelectedSubCategoryId(editData.subCategory.id)
//             setActiveStep(0);
//         }
//     }, [editData]);

//     useEffect(() => {
//         dispatch(getAllCategory());
//         dispatch(getVendors());
//         dispatch(getAllBrand());
//         dispatch(getAllColor());
//         dispatch(getAllSize());
//     }, [dispatch]);

//     const handleNext = () => setActiveStep((prev) => prev + 1);
//     const handleBack = () => setActiveStep((prev) => prev - 1);

//     const brandOptions = React.useMemo(() => {
//         if (!Array.isArray(brands?.brands?.response)) return [];
//         return brands.brands.response
//             .map((b) => b?.name)
//             .filter(Boolean);
//     }, [brands]);

//     // ================= FINAL SUBMIT =================
//     const handleFinalSubmit = async () => {

//         const payload = {
//             vendorId: productData.vendorId,
//             title: productData.title,
//             description: productData.description,
//             categoryId: productData.categoryId,
//             subCategoryId: productData.subCategoryId,
//             productCategoryId: productData.productCategoryId,
//             brandName: productData.brandName,
//             colorId: productData.colorId,
//             productColorId: productData.productColorId,
//             gst: productData.gst,
//             returnAllowed: productData.returnAllowed,
//             customizationAllowed: productData.customizationAllowed,
//             customizationPrice: productData.customizationPrice,

//             // 🔥 VARIANTS CLEANED
//             variants: productData.variants.map((item) => ({
//                 id: item.id || null,
//                 sizeId: item.sizeId,
//                 price: item.price,
//                 stockQuantity: item.stockQuantity,
//                 vendorDiscountPercentage: item.vendorDiscountPercentage,
//                 marginPrice: item.marginPrice,
//                 adminDiscountPercentage: item.adminDiscountPercentage,
//             })),

//             // 🔥 IMAGES META CLEANED
//             imagesMeta: productData.images.map((img) => ({
//                 id: img.id || null,
//                 isPrimary: img.isPrimary
//             }))
//         };

//         const formData = new FormData();

//         formData.append(
//             "product",
//             new Blob([JSON.stringify(payload)], {
//                 type: "application/json",
//             })
//         );

//         // 🔥 ONLY NEW FILES
//         productData.images.forEach((img) => {
//             if (img.file) {
//                 formData.append("images", img.file);
//             }
//         });

//         if (isEditMode) {
//             dispatch(updateFullProduct(editData.id, formData, handleClose));
//         } else {
//             dispatch(createFullProduct(formData, handleClose));
//         }
//     };

//     const handleClose = () => {
//         setProductData({
//             vendorId: "",
//             title: "",
//             description: "",
//             categoryId: "",
//             subCategoryId: "",
//             productCategoryId: "",
//             brandName: "",
//             colorId: "",
//             productColorId: "",
//             gst: "",
//             returnAllowed: false,
//             customizationAllowed: false,
//             customizationPrice: 0,
//             images: [],
//             variants: []
//         });
//         setSelectedCategoryId(0)
//         setSelectedSubCategoryId(0)
//         setActiveStep(0);
//         onClose();
//     };

//     return (
//         <Dialog
//             open={open}
//             onClose={handleClose}
//             fullScreen={fullScreen}
//             fullWidth
//             maxWidth="md"
//             PaperProps={{
//                 sx: {
//                     borderRadius: 3,
//                     paddingBottom: 2
//                 }
//             }}
//         >

//             {/* ===== HEADER ===== */}
//             <DialogTitle
//                 sx={{
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "space-between",
//                     borderBottom: "1px solid #f0f0f0",
//                     pb: 2
//                 }}
//             >
//                 <Typography variant="h6" fontWeight={600}>
//                     {isEditMode ? "Update Product" : "Add Product"}
//                 </Typography>

//                 <IconButton disabled={vendorProducts.loading} onClick={handleClose}>
//                     <CloseIcon />
//                 </IconButton>
//             </DialogTitle>

//             <DialogContent sx={{ mt: 2 }}>

//                 {/* ===== STEPPER ===== */}
//                 <Stepper
//                     activeStep={activeStep}
//                     alternativeLabel
//                     sx={{ mb: 4 }}
//                 >
//                     {steps.map((label) => (
//                         <Step key={label}>
//                             <StepLabel>{label}</StepLabel>
//                         </Step>
//                     ))}
//                 </Stepper>

//                 {/* ===== STEP CONTENT ===== */}

//                 {activeStep === 0 && (
//                     <DetailTabContent
//                         productData={productData}
//                         setProductData={setProductData}
//                         publicCategory={publicCategory}
//                         adminVendor={adminVendor}
//                         color={color}
//                         brandOptions={brandOptions}
//                         selectedCategoryId={selectedCategoryId}
//                         setSelectedCategoryId={setSelectedCategoryId}
//                         selectedSubCategoryId={selectedSubCategoryId}
//                         setSelectedSubCategoryId={setSelectedSubCategoryId}
//                         onNext={handleNext}
//                     />
//                 )}

//                 {activeStep === 1 && (
//                     <ImageTabContent
//                         productData={productData}
//                         setProductData={setProductData}
//                         onNext={handleNext}
//                         onBack={handleBack}
//                     />
//                 )}

//                 {activeStep === 2 && (
//                     <VariantTabContent
//                         productData={productData}
//                         setProductData={setProductData}
//                         size={size}
//                         onNext={handleNext}
//                         onBack={handleBack}
//                     />
//                 )}

//                 {/* {activeStep === 3 && (
//                     <AttributeTabContent
//                         productData={productData}
//                         setProductData={setProductData}
//                         onNext={handleNext}
//                         onBack={handleBack}
//                     />
//                 )} */}

//                 {activeStep === 3 && (
//                     <FinalTabContent
//                         productData={productData}
//                         onBack={handleBack}
//                         onSubmit={handleFinalSubmit}
//                         loading={vendorProducts.loading}
//                         isEditMode={isEditMode}
//                     />
//                 )}

//             </DialogContent>
//         </Dialog>
//     );
// };

// export default ManageProductModal;


import React, { useEffect, useState, useMemo } from "react";
import {
    Dialog,
    DialogContent,
    DialogTitle,
    Stepper,
    Step,
    StepLabel,
    IconButton,
    Typography,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import DetailTabContent from "./DetailTabContent";
import ImageTabContent from "./ImageTabContent";
import VariantTabContent from "./VariantTabContent";
import FinalTabContent from "./FinalTabContent";

import { useDispatch, useSelector } from "react-redux";
import { getAllCategory } from "../../../User/State/Category/Action";
import { getVendors } from "../../State/Vendor/Action";
import { getAllBrand } from "../../../User/State/Brand/Action";
import { getAllColor } from "../../../User/State/Color/Action";
import { getAllSize } from "../../../User/State/Size/Action";
import {
    createFullProduct,
    updateFullProduct,
} from "../../../Vendor/State/Product/Action";
import { getVendorProfile } from "../../../Vendor/State/Vendor/Action";
import AttributeTabContent from "./AttributeTabContent";

const steps = ["Details", "Images", "Variants", "Attributes", "Finish"];

const initialState = {
    vendorId: "",
    title: "",
    description: "",
    categoryId: "",
    subCategoryId: "",
    productCategoryId: "",
    brandName: "",
    productColorId: "",
    colorId: "",
    gst: "",
    returnAllowed: false,
    customizationAllowed: false,
    customizationPrice: 0,
    images: [],
    variants: [],
    attributes: [],
};

const ProductManageModal = ({ open, onClose, editData }) => {
    const dispatch = useDispatch();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

    const { vendorProfile, vendorProducts, size, color, publicCategory, adminVendor, brands } =
        useSelector((store) => store);

    const isEditMode = Boolean(editData);

    const [activeStep, setActiveStep] = useState(0);
    const [selectedCategoryId, setSelectedCategoryId] = useState(0);
    const [selectedSubCategoryId, setSelectedSubCategoryId] = useState(0);
    const [productData, setProductData] = useState(initialState);

    const showFields = Boolean(!vendorProfile.vendor); // or from prop

    // ================= LOAD EDIT DATA =================
    useEffect(() => {
        if (!editData) return;

        setProductData({
            vendorId: editData.vendor?.id || "",
            title: editData.title || "",
            description: editData.description || "",
            categoryId: editData.category?.id || "",
            subCategoryId: editData.subCategory?.id || "",
            productCategoryId: editData.productCategory?.id || "",
            colorId: editData.colors?.[0]?.color?.id || "",
            productColorId: editData.colors?.[0]?.id || "",
            brandName: editData.brand?.name || "",
            gst: editData.igst || "",
            returnAllowed:
                editData?.returnAllowed?.toLowerCase() === "yes" ? true : false,
            customizationAllowed: editData?.customizationAllowed || false,
            customizationPrice: editData?.customizationPrice || 0,

            images:
                editData.images?.map((img) => ({
                    id: img.id,
                    tempId: null,
                    preview: img.fullUrl,
                    isPrimary: img.isPrimary,
                    file: null,
                })) || [],

            variants:
                editData.variants?.map((v) => ({
                    id: v.id,
                    tempId: null,
                    sizeId: v.size?.id,
                    price: v.price,
                    stockQuantity: v.stockQuantity,
                    vendorDiscountPercentage: v.vendorDiscountPercentage,
                    marginPrice: v.marginPrice,
                    adminDiscountPercentage: v.adminDiscountPercentage,
                })) || [],

            attributes: editData?.attributes?.map((a) => ({
                id: a.id,
                name: a.name,
                value: a.value
            })) || []
        });

        setSelectedCategoryId(editData.category?.id || 0);
        setSelectedSubCategoryId(editData.subCategory?.id || 0);
        setActiveStep(0);
    }, [editData]);
    console.log("edit data", editData)
    // ================= LOAD MASTER DATA =================
    useEffect(() => {
        dispatch(getAllCategory());
        dispatch(getVendors());
        dispatch(getAllBrand());
        dispatch(getAllColor());
        dispatch(getAllSize());
        dispatch(getVendorProfile())
    }, [dispatch]);

    const brandOptions = useMemo(() => {
        if (!Array.isArray(brands?.brands?.response)) return [];
        return brands.brands.response.map((b) => b?.name).filter(Boolean);
    }, [brands]);

    // ================= VALIDATION =================
    const validateBeforeSubmit = () => {
        if (!productData.title) return alert("Title required");
        if (!productData.categoryId) return alert("Category required");
        if (!productData.productCategoryId)
            return alert("Product category required");

        if (!productData.images.length)
            return alert("At least one image required");

        const hasPrimary = productData.images.some(
            (img) => img.isPrimary === true
        );

        if (!hasPrimary) return alert("Primary image required");

        if (!productData.variants.length)
            return alert("At least one variant required");

        return true;
    };

    // ================= FINAL SUBMIT =================
    const handleFinalSubmit = () => {
        console.log("submit data product ;", productData)
        if (!validateBeforeSubmit()) return;

        const imagesMeta = [];
        const newFiles = [];

        productData.images.forEach((img) => {
            imagesMeta.push({
                id: img.id || null,
                isPrimary: img.isPrimary,
            });

            if (img.file) {
                newFiles.push(img.file);
            }
        });

        const payload = {
            vendorId: productData.vendorId,
            title: productData.title,
            description: productData.description,
            categoryId: productData.categoryId,
            subCategoryId: productData.subCategoryId,
            productCategoryId: productData.productCategoryId,
            brandName: productData.brandName,
            colorId: productData.colorId,
            productColorId: productData.productColorId,
            gst: productData.gst,
            returnAllowed: productData.returnAllowed,
            customizationAllowed: productData.customizationAllowed,
            customizationPrice: productData.customizationPrice,
            variants: productData.variants.map((v) => ({
                id: v.id || null,
                sizeId: v.sizeId,
                price: v.price,
                stockQuantity: v.stockQuantity,
                vendorDiscountPercentage: v.vendorDiscountPercentage,
                marginPrice: v.marginPrice,
                adminDiscountPercentage: v.adminDiscountPercentage,
            })),
            imagesMeta,
            attributes: productData.attributes?.map((a) => ({
                id: a.id || null,
                name: a.name,
                value: a.value
            }))
        };

        console.log("submit data payload ;", payload)
        const formData = new FormData();

        formData.append(
            "product",
            new Blob([JSON.stringify(payload)], {
                type: "application/json",
            })
        );

        console.log("final submit data ;", newFiles)
        newFiles.forEach((file) => {
            formData.append("images", file);
            console.log("submit data form ;", file)
        });
        console.log("final submit data ;", formData)
        if (isEditMode) {
            dispatch(updateFullProduct(editData.id, formData, handleClose));
        } else {
            dispatch(createFullProduct(formData, handleClose));
        }
    };

    // ================= CLOSE =================
    const handleClose = () => {
        setProductData(initialState);
        setSelectedCategoryId(0);
        setSelectedSubCategoryId(0);
        setActiveStep(0);
        onClose();
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            fullScreen={fullScreen}
            fullWidth
            maxWidth="md"
            PaperProps={{
                sx: { borderRadius: 3, pb: 2 },
            }}
        >
            <DialogTitle
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    borderBottom: "1px solid #eee",
                }}
            >
                <Typography variant="h6" fontWeight={600}>
                    {isEditMode ? "Update Product" : "Add Product"}
                </Typography>

                <IconButton
                    disabled={vendorProducts.loading}
                    onClick={handleClose}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent sx={{ mt: 2 }}>
                <Stepper activeStep={activeStep} alternativeLabel sx={{ mb: 4 }}>
                    {steps.map((label) => (
                        <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>

                {activeStep === 0 && (
                    <DetailTabContent
                        productData={productData}
                        setProductData={setProductData}
                        publicCategory={publicCategory}
                        adminVendor={adminVendor}
                        color={color}
                        brandOptions={brandOptions}
                        selectedCategoryId={selectedCategoryId}
                        setSelectedCategoryId={setSelectedCategoryId}
                        selectedSubCategoryId={selectedSubCategoryId}
                        setSelectedSubCategoryId={setSelectedSubCategoryId}
                        showFields={showFields}
                        isEditMode={isEditMode}
                        onNext={() => setActiveStep(1)}
                    />
                )}

                {activeStep === 1 && (
                    <ImageTabContent
                        productData={productData}
                        setProductData={setProductData}
                        onNext={() => setActiveStep(2)}
                        onBack={() => setActiveStep(0)}
                    />
                )}

                {activeStep === 2 && (
                    <VariantTabContent
                        productData={productData}
                        setProductData={setProductData}
                        size={size}
                        showFields={showFields}
                        onNext={() => setActiveStep(3)}
                        onBack={() => setActiveStep(1)}
                    />
                )}

                {activeStep === 3 && (
                    <AttributeTabContent
                        productData={productData}
                        setProductData={setProductData}
                        onNext={() => setActiveStep(4)}
                        onBack={() => setActiveStep(2)}
                    />
                )}

                {activeStep === 4 && (
                    <FinalTabContent
                        productData={productData}
                        size={size}
                        categories={publicCategory}
                        color={color}
                        onBack={() => setActiveStep(3)}
                        onSubmit={handleFinalSubmit}
                        loading={vendorProducts.loading}
                        isEditMode={isEditMode}
                    />
                )}
            </DialogContent>
        </Dialog>
    );
};

export default ProductManageModal;